import { StateSchema } from 'app/providers/StoreProvider';

import { OrderStatuses } from '../consts/orderStatuses';

export const getOrdersSearchParams = (state: StateSchema) =>
    state.order?.searchParams;

export const getOrdersSearchParamsStatus = (state: StateSchema) =>
    state.order?.searchParams?.status;

export const getSelectedOrder = (state: StateSchema) =>
    state.order?.selectedData;

export const getSelectedOrderIsLoading = (state: StateSchema) =>
    state.order?.dataIsLoading;

export const getSelectedPoNumberIsLoading = (state: StateSchema) =>
    state.order?.poNumberIsLoading;

export const getSelectedOrderId = (state: StateSchema) =>
    state.order?.selectedData?.id;

export const getSelectedOrderPropertyId = (state: StateSchema) =>
    state.order?.selectedData?.property;

export const getSelectedOrderItems = (state: StateSchema) =>
    state.order?.selectedData?.items;

export const getSelectedOrderType = (state: StateSchema) =>
    state.order?.selectedData?.orderType === 'RENOVATION'
        ? 'Renovations'
        : 'Operations';

export const getSelectedOrderStatus = (state: StateSchema) =>
    state.order?.selectedData?.status;

export const getSelectedOrderSummary = (state: StateSchema) =>
    state.order.orderSummary;

export const getInteractionStatus = (state: StateSchema) =>
    state.order?.interactionStatus;

export const getShipmentStatus = (state: StateSchema) =>
    state.order?.shipmentStatus;

export const getInvoiceStatus = (state: StateSchema) =>
    state.order?.invoiceStatus;

export const getSelectedOrderCreatorName = (state: StateSchema) => {
    const creator = state.order?.selectedData?.creator;
    return `${creator?.firstName || ''} ${creator?.lastName || ''} `;
};

export const getSelectedOrderIsPreSubmission = (state: StateSchema) => {
    const status = state.order?.selectedData?.status;
    return [
        OrderStatuses.DRAFT,
        OrderStatuses.IN_REVIEW,
        OrderStatuses.PENDING_APPROVAL,
    ].includes(status);
};
